// Entity Type Utilities
// This file provides utilities for consistent entity type display across components
import { TYPE_PROFILE, getProfileByValue } from "./typeProfile";

/**
 * Get entity types - now using static TYPE_PROFILE enum since entity types don't change
 */
export async function getEntityTypesWithCache() {
  // Convert TYPE_PROFILE object to array format
  return Object.values(TYPE_PROFILE).map((p) => ({
    value: p.value,
    label: p.label,
    icon: p.icon,
    color: p.color,
  }));
}

/**
 * Get entity type info by value/name
 */
export async function getEntityTypeInfo(entityTypeValue) {
  const types = await getEntityTypesWithCache();
  const fromApi = types.find(
    (t) => t.value === entityTypeValue || t.name === entityTypeValue
  );
  const fromProfile = getProfileByValue(entityTypeValue);
  return fromProfile
    ? {
        ...fromApi,
        ...fromProfile,
        label: fromProfile.label,
        color: fromProfile.color,
        icon: fromProfile.icon,
      }
    : fromApi;
}

